import { useTracker } from '@jetshop/core/analytics/Analytics';
import get from 'lodash.get';
import { useCallback } from 'react';
import { trackProductEvent } from '@jetshop/core/analytics/tracking';
export function getArticleNumber(product, selectedVariation) {
    return product.variants.values.length > 0
        ? get(selectedVariation, 'articleNumber')
        : get(product, 'articleNumber');
}
export function useTrackProductAdd(selectedVariation) {
    const track = useTracker();
    return useCallback(function trackProductVariant(product, quantity) {
        track(trackProductEvent({
            action: 'add',
            product,
            quantity,
            selectedVariation
        }));
    }, [selectedVariation, track]);
}
export function getCommentsFromFormikValues(values) {
    return Object.keys(values.comments).map(name => {
        return {
            name,
            value: values.comments[name]
        };
    });
}
export function addToCartSuccess({ onAddToCartSuccess, callbackOptions, cartId, setCartId }) {
    return ({ data }) => {
        if (!cartId || data.addToCart.cart.id !== cartId) {
            data.addToCart && setCartId(data.addToCart.cart.id);
        }
        onAddToCartSuccess && onAddToCartSuccess(callbackOptions);
    };
}
export function addToCartError({ onAddToCartError, callbackOptions }) {
    return (error) => {
        console.error('useCartAdder error', error);
        if (!onAddToCartError) {
            throw error;
        }
        onAddToCartError(Object.assign(Object.assign({}, callbackOptions), { error }));
    };
}
//# sourceMappingURL=addToCartUtils.js.map